// // // const AboutUs = () => {
// // //   const content = [
// // //     {
// // //       heading: "ABOUT",
// // //       desc: "Jurident is a modern legal-tech platform built to simplify the way people seek, access, and manage legal support. Whether you're an individual confused about your legal options or a lawyer looking to streamline your practice, Jurident bridges the gap with a seamless, secure, and AI-assisted experience. From fetching court cases, matching with verified lawyers, and scheduling consultations, to drafting legal documents and managing proceedings — Jurident brings the entire legal process under one digital roof. Designed with clarity and trust at its core, the platform eliminates middlemen, protects against misinformation, and empowers users to make informed legal decisions."
// // //     },
// // //     {
// // //       heading: "VISION",
// // //       desc: "Jurident envisions a world where legal support is not a privilege but a right — accessible, understandable, and reliable for everyone, regardless of their background or legal knowledge. We strive to bridge the gap between the complexities of the legal system and the people who need help navigating it. By leveraging technology and simplifying legal interactions, our vision is to empower individuals and legal professionals alike with tools that ensure justice is approachable, transparent, and timely."
// // //     },
// // //     {
// // //       heading: "GOAL",
// // //       desc: "Our goal is to create a comprehensive, intelligent legal platform that addresses real-world challenges faced by clients and lawyers. From helping users identify their legal issues with clarity to connecting them with verified legal professionals, Jurident focuses on making every step of the legal journey smoother. We aim to eliminate misinformation, reduce dependency on unreliable intermediaries, and streamline documentation, communication, and case tracking — all while ensuring privacy, trust, and professional integrity."
// // //     }
// // //   ];

// // //   return (
// // //     <div className="relative w-full min-h-screen flex justify-center items-start overflow-auto bg-white">
// // //       {/* Background image stays as it is */}
// // //      <img 
// // //   src="Group 967.png" 
// // //   className="absolute mt-[240px] w-[20%] sm:w-[15%] opacity-20 sm:opacity-100 z-0 pointer-events-none" 
// // //   alt="Decoration" />
        
// // //       {/* Content container */}
// // // <div className="z-10 w-[92%] sm:w-[70%] m-[10px] sm:m-[50px] mt-[100px] lg:mt-[140px] space-y-8">
// // //         {content.map((item, index) => (
// // //           <div
// // //             key={index}
// // //             className="about-card bg-white sm:bg-transparent rounded-xl sm:rounded-none p-5 sm:p-0 border border-[#e5e5e5] sm:border-none"
// // //           >
// // //             <h2 className="text-[14px] sm:text-[22px] font-medium text-[#cda454] mb-2 tracking-wide uppercase">
// // //               {item.heading}
// // //             </h2>
// // //             <p className="text-[13px] sm:text-[19.5px] text-justify font-normal leading-[1.6] sm:leading-[1.8] text-[#222]">
// // //               {item.desc}
// // //             </p>
// // //           </div>
// // //         ))}
// // //       </div>

// // //       {/* Metallic Glass Effect */}
// // //       <style>{`
// // //         @media (max-width: 640px) {
// // //           .about-card {
// // //             background: linear-gradient(
// // //               145deg,
// // //               rgba(255, 255, 255, 0.25),
// // //               rgba(255, 255, 255, 0.1)
// // //             );
// // //             backdrop-filter: blur(10px);
// // //             -webkit-backdrop-filter: blur(10px);
// // //             border-radius: 16px;
// // //             border: 1px solid rgba(255, 255, 255, 0.25);
// // //             box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1), inset 0 1px 1px rgba(255,255,255,0.3);
// // //             transition: all 0.3s ease;
// // //           }

// // //           .about-card:hover {
// // //             box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15), inset 0 2px 2px rgba(255,255,255,0.35);
// // //           }
// // //         }
// // //       `}</style>
// // //     </div>
// // //   );
// // // };

// // // export default AboutUs;










// // import { motion } from "framer-motion";

// // const AboutUs = () => {
// //   const content = [
// //     {
// //       heading: "ABOUT",
// //       desc: "Jurident is a modern legal-tech platform built to simplify the way people seek, access, and manage legal support. Whether you're an individual confused about your legal options or a lawyer looking to streamline your practice, Jurident bridges the gap with a seamless, secure, and AI-assisted experience. From fetching court cases, matching with verified lawyers, and scheduling consultations, to drafting legal documents and managing proceedings — Jurident brings the entire legal process under one digital roof. Designed with clarity and trust at its core, the platform eliminates middlemen, protects against misinformation, and empowers users to make informed legal decisions."
// //     },
// //     {
// //       heading: "VISION",
// //       desc: "Jurident envisions a world where legal support is not a privilege but a right — accessible, understandable, and reliable for everyone, regardless of their background or legal knowledge. We strive to bridge the gap between the complexities of the legal system and the people who need help navigating it. By leveraging technology and simplifying legal interactions, our vision is to empower individuals and legal professionals alike with tools that ensure justice is approachable, transparent, and timely."
// //     },
// //     {
// //       heading: "GOAL",
// //       desc: "Our goal is to create a comprehensive, intelligent legal platform that addresses real-world challenges faced by clients and lawyers. From helping users identify their legal issues with clarity to connecting them with verified legal professionals, Jurident focuses on making every step of the legal journey smoother. We aim to eliminate misinformation, reduce dependency on unreliable intermediaries, and streamline documentation, communication, and case tracking — all while ensuring privacy, trust, and professional integrity."
// //     }
// //   ];

// //   return (
// //     <div className="relative w-full min-h-screen flex justify-center items-start overflow-auto bg-white">
      
// //       {/* Background image stays same */}
// //       <img 
// //         src="Group 967.png" 
// //         className="absolute mt-[240px] w-[20%] sm:w-[15%] opacity-20 sm:opacity-100 z-0 pointer-events-none" 
// //         alt="Decoration"
// //       />

// //       {/* Content container */}
// //       <div className="z-10 w-[92%] sm:w-[70%] m-[10px] sm:m-[50px] mt-[100px] lg:mt-[140px] space-y-10">
// //         {content.map((item, index) => (
// //           <motion.div
// //             key={index}
// //             initial={{ opacity: 0, y: 40 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             viewport={{ once: true }}
// //             transition={{ duration: 0.6, delay: index * 0.15 }}
// //             whileHover={{ y: -6 }}
// //             className="about-card bg-white sm:bg-transparent rounded-xl sm:rounded-none p-5 sm:p-0 border border-[#e5e5e5] sm:border-none"
// //           >
// //             <div className="flex items-center gap-3 mb-3">
// //               <span className="w-8 h-[2px] bg-gradient-to-r from-[#cda454] to-transparent"></span>
// //               <h2 className="text-[14px] sm:text-[22px] font-medium text-[#cda454] tracking-wide uppercase">
// //                 {item.heading}
// //               </h2>
// //             </div>

// //             <p className="text-[13px] sm:text-[19.5px] text-justify font-normal leading-[1.6] sm:leading-[1.8] text-[#222]">
// //               {item.desc}
// //             </p>
// //           </motion.div>
// //         ))}
// //       </div>

// //       {/* Metallic Glass Effect (Improved) */}
// //       <style>{`
// //         @media (max-width: 640px) {
// //           .about-card {
// //             background: linear-gradient(
// //               145deg,
// //               rgba(255, 255, 255, 0.35),
// //               rgba(255, 255, 255, 0.12)
// //             );
// //             backdrop-filter: blur(14px);
// //             -webkit-backdrop-filter: blur(14px);
// //             border-radius: 18px;
// //             border: 1px solid rgba(255, 255, 255, 0.28);
// //             box-shadow:
// //               0 10px 30px rgba(0, 0, 0, 0.12),
// //               inset 0 1px 1px rgba(255,255,255,0.35);
// //             transition: all 0.35s ease;
// //           }

// //           .about-card:hover {
// //             transform: translateY(-4px);
// //             box-shadow:
// //               0 18px 40px rgba(0, 0, 0, 0.18),
// //               inset 0 2px 2px rgba(255,255,255,0.4);
// //           }
// //         }
// //       `}</style>
// //     </div>
// //   );
// // };

// // export default AboutUs;


























// import { motion } from "framer-motion";

// const AboutUs = () => {
//   const content = [
//     {
//       heading: "ABOUT",
//       desc: "Jurident is a modern legal-tech platform built to simplify the way people seek, access, and manage legal support. Whether you're an individual confused about your legal options or a lawyer looking to streamline your practice, Jurident bridges the gap with a seamless, secure, and AI-assisted experience. From fetching court cases, matching with verified lawyers, and scheduling consultations, to drafting legal documents and managing proceedings — Jurident brings the entire legal process under one digital roof. Designed with clarity and trust at its core, the platform eliminates middlemen, protects against misinformation, and empowers users to make informed legal decisions."
//     },
//     {
//       heading: "VISION",
//       desc: "Jurident envisions a world where legal support is not a privilege but a right — accessible, understandable, and reliable for everyone, regardless of their background or legal knowledge. We strive to bridge the gap between the complexities of the legal system and the people who need help navigating it. By leveraging technology and simplifying legal interactions, our vision is to empower individuals and legal professionals alike with tools that ensure justice is approachable, transparent, and timely."
//     },
//     {
//       heading: "GOAL",
//       desc: "Our goal is to create a comprehensive, intelligent legal platform that addresses real-world challenges faced by clients and lawyers. From helping users identify their legal issues with clarity to connecting them with verified legal professionals, Jurident focuses on making every step of the legal journey smoother. We aim to eliminate misinformation, reduce dependency on unreliable intermediaries, and streamline documentation, communication, and case tracking — all while ensuring privacy, trust, and professional integrity."
//     }
//   ];

//   return (
//     <div className="relative w-full min-h-screen bg-white flex justify-center overflow-hidden">

//       {/* Decorative background */}
//       <img
//         src="Group 967.png"
//         className="absolute top-[45%] w-[20%] sm:w-[15%] opacity-20 sm:opacity-100 z-0 pointer-events-none"
//         alt="Decoration"
//       />

//       {/* Content */}
//       <div className="relative z-10 w-[92%] sm:w-[70%] mt-[100px] lg:mt-[140px] space-y-12 pb-20">

//         {content.map((item, index) => (
//           <motion.section
//             key={index}
//             initial={{ opacity: 0, y: 50 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.7, delay: index * 0.2 }}
//             whileHover={{ y: -6 }}
//             className="about-card group"
//           >
//             {/* Heading */}
//             <div className="flex items-center gap-4 mb-4">
//               <span className="h-[2px] w-10 bg-gradient-to-r from-[#cda454] to-transparent" />
//               <h2 className="text-[14px] sm:text-[24px] font-semibold text-[#cda454] tracking-widest uppercase">
//                 {item.heading}
//               </h2>
//             </div>

//             {/* Text */}
//             <p className="text-[13.5px] sm:text-[19.5px] text-justify leading-[1.7] sm:leading-[1.9] text-[#222]">
//               {item.desc}
//             </p>
//           </motion.section>
//         ))}
//       </div>

//       {/* Styles */}
//       <style>{`
//         /* Base card */
//         .about-card {
//           background: transparent;
//           padding: 0;
//           transition: all 0.4s ease;
//         }

//         /* Mobile & tablet glass */
//         @media (max-width: 768px) {
//           .about-card {
//             background: linear-gradient(
//               145deg,
//               rgba(255, 255, 255, 0.38),
//               rgba(255, 255, 255, 0.15)
//             );
//             backdrop-filter: blur(14px);
//             -webkit-backdrop-filter: blur(14px);
//             border-radius: 20px;
//             padding: 22px;
//             border: 1px solid rgba(255, 255, 255, 0.28);
//             box-shadow:
//               0 12px 32px rgba(0, 0, 0, 0.12),
//               inset 0 1px 1px rgba(255,255,255,0.35);
//           }
//         }

//         /* Desktop subtle depth */
//         @media (min-width: 769px) {
//           .about-card {
//             padding: 10px 0;
//           }

//           .about-card:hover {
//             transform: translateY(-4px);
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AboutUs;











import { motion } from "framer-motion";

const AboutUs = () => {
  const content = [
    {
      heading: "OUR VISION",
      desc: "To transform the legal ecosystem by building a unified LegalTech platform where lawyers, organizations, clients, and law students can collaborate efficiently. JURIDENT envisions a future where legal operations, especially high-volume case management, are streamlined through technology, making them faster, smarter, and more transparent."
    },
    {
      heading: "OUR MISSION",
      desc: "Our mission is to simplify legal workflows through AI-powered tools, enabling lawyers, law firms, and companies to manage cases, automate documentation, and improve communication. We aim to reduce manual effort, increase productivity, and provide a scalable platform for both individual practitioners and organizations handling complex legal operations."
    },
    {
      heading: "OUR GOAL",
      desc: "JURIDENT aims to bridge the gap between legal practice and technology by offering a complete legal practice management platform."
    }
  ];

  return (
    <section className="relative w-full min-h-screen bg-white overflow-hidden">

      {/* Decorative mark */}
      <img
        src="Group 967.png"
        className="absolute right-[8%] top-[40%] w-[14%] opacity-20 hidden lg:block"
        alt="Decoration"
      />

      {/* Container */}
<div className="relative z-10 max-w-6xl mx-auto px-6 pt-32 sm:pt-[110px] lg:pt-[150px] pb-32">

        {/* Page Intro */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <h1 className="text-[32px] sm:text-[44px] font-extrabold tracking-tight text-[#111] leading-tight">
            Redefining how legal
            <span className="block text-[#cda454]">services are accessed</span>
          </h1>

          <p className="mt-6 max-w-2xl text-[15px] sm:text-[18px] text-[#555] leading-relaxed">
            Managing 1,000+ cases is now easier with JURIDENT the all-in-one LegalTech platform for lawyers, law firms, companies, and law students.
JURIDENT is a software platform developed and owned by Valsco Technology Pvt. Ltd.
          </p>
        </motion.div>

        {/* Vertical Timeline */}
        <div className="relative border-l border-[#cda454]/40 pl-10 space-y-24">

          {content.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="relative"
            >
              {/* Gold Dot */}
              <span className="absolute -left-[11px] top-2 w-4 h-4 rounded-full bg-[#cda454] shadow-[0_0_20px_rgba(205,164,84,0.6)]" />

              {/* Card */}
              <div className="bg-white/70 backdrop-blur-xl rounded-2xl p-8
                shadow-[0_20px_60px_rgba(0,0,0,0.08)]
                border border-[#cda454]/10
                transition-all duration-500 hover:-translate-y-2"
              >
                <h2 className="text-[13px] tracking-[0.3em] text-[#cda454] font-semibold mb-4">
                  {item.heading}
                </h2>

                <p className="text-[14px] sm:text-[18px] leading-[1.9] text-[#222]">
                  {item.desc}
                </p>
              </div>
            </motion.div>
            
          ))}
        </div>
      </div>

      {/* 🔥 FEATURES / PLATFORM CAPABILITIES SECTION */}
<motion.div
  initial={{ opacity: 0, y: 80 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.9 }}
  className="max-w-6xl mx-auto px-6 pb-32"
>

  {/* Heading */}
  <div className="text-center mb-16">
    <h2 className="text-[28px] sm:text-[40px] font-extrabold text-[#111]">
      Powerful Features for Modern Legal Workflows
    </h2>
    <p className="mt-4 text-[#666] text-[15px] sm:text-[18px] max-w-2xl mx-auto">
      Built to simplify legal operations, improve transparency, and scale efficiently.
    </p>
  </div>

  {/* Grid */}
  <div className="grid md:grid-cols-2 gap-10">

    {/* LEFT - LAWYERS */}
    <div className="bg-white/70 backdrop-blur-xl rounded-2xl p-8 shadow-lg border border-[#cda454]/10 hover:-translate-y-2 transition duration-500">
      <h3 className="text-[#cda454] text-[18px] tracking-widest mb-4 font-semibold">
        FOR LAWYERS & LAW FIRMS
      </h3>

      <ul className="space-y-3 text-[#333] text-[15px] leading-relaxed">
        <li>• Manage cases, clients, and documents in one platform</li>
        <li>• Track hearings, notes, and next hearing dates</li>
        <li>• Automate legal document drafting using AI</li>
        <li>• Add expenses and generate invoices for cases</li>
        <li>• Collaborate with team members and juniors</li>
        <li>• Handle multiple and high-volume cases efficiently</li>
        <li>• AI at your ease</li>
      </ul>
    </div>

    {/* RIGHT - CLIENTS */}
    <div className="bg-white/70 backdrop-blur-xl rounded-2xl p-8 shadow-lg border border-[#cda454]/10 hover:-translate-y-2 transition duration-500">
      <h3 className="text-[#cda454] text-[18px] tracking-widest mb-4 font-semibold">
        FOR ORGANIZATIONS & CLIENTS
      </h3>

      <ul className="space-y-3 text-[#333] text-[15px] leading-relaxed">

        <li>• Track ongoing legal cases in real-time</li>
        <li>• View case updates, hearing dates, and progress</li>
        <li>• Monitor expenses added by lawyers</li>
        <li>• Access invoices directly on the dashboard</li>
        <li>• Manage multiple legal matters from one platform</li>
        <li>• Use AI for notice summarization for organizations.</li>
        <li>• Communicate seamlessly with lawyers</li>
      </ul>
    </div>

  </div>

  {/* 🔥 SYNC SECTION */}
  <div className="mt-20 bg-gradient-to-r from-[#cda454]/10 to-transparent rounded-2xl p-10 border border-[#cda454]/20">

    <h3 className="text-[22px] sm:text-[28px] font-bold text-[#111] mb-6">
      Real-Time Case & Billing Synchronization
    </h3>

    <p className="text-[#555] mb-8 text-[15px] sm:text-[17px]">
      JURIDENT enables complete synchronization between lawyers and clients for cases, expenses, and billing all in one platform.
    </p>

    <div className="grid md:grid-cols-2 gap-8 text-[#333]">

      <div>
      <h4 className="font-semibold text-[#cda454] mb-2 text-[18px] sm:text-[22px]">
  Case Updates
</h4>
        <p>Lawyers update case details, notes, and hearing dates instantly visible to clients.</p>
      </div>

      <div>
         <h4 className="font-semibold text-[#cda454] mb-2 text-[18px] sm:text-[22px]">Expense Tracking</h4>
        <p>Clients can transparently track legal expenses added by lawyers.</p>
      </div>

      <div>
         <h4 className="font-semibold text-[#cda454] mb-2 text-[18px] sm:text-[22px]">Invoice Generation</h4>
        <p>Raise and share invoices directly with clients in real-time.</p>
      </div>

      <div>
        <h4 className="font-semibold text-[#cda454] mb-2 text-[18px] sm:text-[22px]">Unified System</h4>
        <p>All updates sync across dashboards for smooth workflow and communication.</p>
      </div>

    </div>
  </div>

  {/* 🔥 WHY JURIDENT */}
  <div className="mt-20 text-center">

    <h3 className="text-[24px] sm:text-[32px] font-bold text-[#111] mb-10">
      Jurident
    </h3>

    <div className="grid md:grid-cols-3 gap-8">

      <div className="p-6 rounded-xl bg-white shadow-md border border-[#cda454]/10">
      <h4 className="font-semibold text-[#cda454] mb-2 text-[18px] sm:text-[22px]">All-in-One Platform</h4>
        <p className="text-[#555] text-[16px]">Manage cases, clients, billing, and communication in one place.</p>
      </div>

      <div className="p-6 rounded-xl bg-white shadow-md border border-[#cda454]/10">
     <h4 className="font-semibold text-[#cda454] mb-2 text-[18px] sm:text-[22px]">Built for Scale</h4>
        <p className="text-[#555] text-[16px]">Designed for high-volume legal operations and firms.</p>
      </div>

      <div className="p-6 rounded-xl bg-white shadow-md border border-[#cda454]/10">
      <h4 className="font-semibold text-[#cda454] mb-2 text-[18px] sm:text-[22px]">AI Powered</h4>
        <p className="text-[#555] text-[16px]">Case summarization, legal notices, drafting, and much more all at your ease.</p>
      </div>

    </div>

    <p className="mt-10 text-[#666] text-[17px]">
      Also built for law students to access internships and real-world exposure.
    </p>

  </div>

</motion.div>
{/* Founder Section */}
{/* 🔥 ULTRA PREMIUM FOUNDER SECTION */}
<motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 1 }}
  className="relative max-w-6xl mx-auto px-6 pb-36"
>

  {/* Background Glow */}
  <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
    <div className="w-[500px] h-[500px] bg-[#cda454]/10 blur-[120px] rounded-full"></div>
  </div>

  <div className="relative grid md:grid-cols-2 gap-16 items-center">

    {/* 🔥 LEFT: IMAGE CARD */}
    <motion.div
      whileHover={{ y: -10 }}
      transition={{ type: "spring", stiffness: 120 }}
      className="relative group flex justify-center"
    >
      {/* Glow background */}
      <div className="absolute w-[280px] h-[280px] bg-[#cda454]/20 blur-3xl rounded-full opacity-70 group-hover:opacity-100 transition duration-500"></div>

      {/* Glass Card */}
      <div className="relative overflow-hidden backdrop-blur-xl bg-white/40 border border-white/30 rounded-[28px] p-3 shadow-[0_30px_100px_rgba(0,0,0,0.2)]">

        {/* ✨ Light Sweep Effect */}
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500">
          <div className="absolute -left-1/2 top-0 w-1/2 h-full bg-white/30 blur-xl rotate-12 translate-x-[-100%] group-hover:translate-x-[200%] transition duration-700"></div>
        </div>

        {/* Image */}
        <img
          src="SIR_VALSCO.jpeg"
          alt="Sanidhya Agarwal"
          className="w-56 h-56 sm:w-72 sm:h-72 object-cover rounded-[20px]
          transition duration-500 group-hover:scale-105"
        />
      </div>
    </motion.div>

    {/* 🔥 RIGHT: CONTENT */}
    <div className="text-center md:text-left">

      {/* Label */}
      <p className="text-[#cda454] tracking-[0.4em] text-[11px] mb-3 uppercase">
        Founder & Visionary
      </p>

      {/* Name */}
      <h2 className="text-[32px] sm:text-[42px] font-extrabold text-[#111] leading-tight">
        Sanidhya Agarwal
      </h2>

      {/* Gradient Divider */}
      <div className="w-20 h-[3px] mt-5 mb-7 bg-gradient-to-r from-[#cda454] to-transparent mx-auto md:mx-0 rounded-full"></div>

      {/* Description */}
      <p className="text-[16px] sm:text-[18px] text-[#444] leading-[1.8] max-w-xl">
        Driving the vision behind Jurident, Sanidhya Agarwal blends strategic leadership with a deep understanding of legal innovation. His commitment to precision, transparency, and excellence is redefining how legal services are experienced—making them more accessible, intelligent, and future-ready.
      </p>

      {/* Signature Line */}
      <p className="mt-6 text-[#cda454] italic text-[14px]">
        “Building the future of legal-tech, one innovation at a time.”
      </p>

    </div>
  </div>
</motion.div>
      {/* Background texture */}
      <style>{`
        section {
          background-image:
            radial-gradient(circle at 1px 1px, rgba(205,164,84,0.06) 1px, transparent 1px);
          background-size: 28px 28px;
        }
      `}</style>
    </section>
  );
};

export default AboutUs;
